import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { CustomStele } from '../../services/stock';

type StockBySteleResponse = {
  price: number;
  stele: CustomStele;
  granitId: string;
};

export const getStocksByStele = async (
  stele?: CustomStele,
): Promise<StockBySteleResponse[] | undefined> => {
  if (!stele) {
    return undefined;
  }
  const { data } = await api.get<StockBySteleResponse[]>(
    `/stock/stele?baseIndex=${stele.baseIndex}&boxDownWidth=${stele.boxDownWidth}&boxHeight=${stele.boxHeight}&boxLeftHeight=${stele.boxLeftHeight}&boxRightHeight=${stele.boxRightHeight}&boxUpWidth=${stele.boxUpWidth}&headIndex=${stele.headIndex}&depth=${stele.depth}`,
  );
  return data;
};

export const useStocksByStele = (stele?: CustomStele) => {
  return useQuery({
    queryKey: ['stocks-by-stele', stele],
    queryFn: () => getStocksByStele(stele),
    retry: false,
    enabled: !!stele,
  });
};
